import React, { useState, useEffect } from 'react';
import './style.css';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import CategoriesNavBar from '../../../Components/CategoriesNavBar/CategoriesNavBar';
import { useParams, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { formatDescription } from '../../../Utills/formatText';
import { t } from '../../../Utills/translations';
import { resolveClientColor } from '../../../Utills/colors';

const { REACT_APP_URL_API } = process.env;
const MAX_DESC_CHARS = 80;

const stripHtml = (html) => html?.replace(/<[^>]*>/g, '') || '';

const truncateText = (text, max) => {
  const plain = stripHtml(text);
  if (plain.length <= max) return plain;
  return plain.substring(0, plain.lastIndexOf(' ', max)) + '...';
};

const Diretorio = () => {
  const [diretorio, setDiretorio] = useState(null);
  const [value, setValue] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const { cliente_id } = useParams();
  const location = useLocation();
  const cookies = new Cookies();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  const userIp = localStorage.getItem('ip_address');
  const session = localStorage.getItem('session');
  const userLanguage = navigator.language || navigator.userLanguage || 'pt-BR';

  const cor_letra = localStorage.getItem('cliente_cor_letra');
  const cor_custom = localStorage.getItem('cliente_cor_custom');

  const raw = JSON.stringify({
    cliente_id: cliente_id,
    ip_address: userIp,
    language: userLanguage,
    session: session,
  });

  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-CSRFToken': cookies.get('csrftoken2'),
  });

  useEffect(() => {
    fetch(
      `${REACT_APP_URL_API}/apiv2/directory/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}&language=${userLanguage}`,
      { method: 'POST', credentials: 'omit', headers, body: raw },
    )
      .then((r) => r.json())
      .then((json) => setDiretorio(json))
      .catch((err) => console.error('Erro ao obter os dados:', err));
  }, [cliente_id, apartamento, cliente_url, session_control]);

  // Bloquear scroll quando modal aberto
  useEffect(() => {
    if (selectedItem) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [selectedItem]);

  if (diretorio === null) return null;

  const navBarColor = cor_custom && cor_custom !== 'outra' ? cor_custom : '#000000';

  const resolvedColor = resolveClientColor();

  const tvItems = diretorio.diretorio.filter((item) => item.tv);
  const nonTvItems = diretorio.diretorio.filter((item) => !item.tv);

  const navCategories = nonTvItems.map((item) => ({
    id: item.id || item.nome_item,
    nome: item.nome_item,
  }));

  const sanitizeId = (str) =>
    String(str).replace(/\s+/g, '-').replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase();

  return (
    <div style={{ paddingTop: '60px' }}>
      <HeaderCardapio />

      <Box sx={{ maxWidth: '930px', margin: '10px auto', left: '1%', right: '1%', bgcolor: 'var(--background-main)' }}>

        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={true}
          sx={{ position: 'sticky', top: '60px', backgroundColor: 'var(--background-main)', zIndex: 97, borderBottom: '1px solid rgba(0,0,0,0.08)' }}
        >
          <Tab label={t('servicos')} style={{ color: 'var(--secondary)' }} />
          {tvItems[0]?.tv && (
            <Tab label={t('canaisTv')} style={{ color: 'var(--secondary)' }} />
          )}
        </Tabs>

        {value === 0 && (
          <div className="MainGrid" style={{ marginBottom: '-60px' }}>
            <div className="div-container-diretorio-servicos">
              <div style={{ marginBottom: '-60px', position: 'fixed', top: '110px', left: 0, right: 0, zIndex: 97 }}>
                {navCategories.length > 0 && (
                  <CategoriesNavBar categories={navCategories} themeColor={navBarColor} offset={-190} />
                )}
              </div>

              <Box sx={{ maxWidth: '930px', margin: '-10px auto 120px auto', left: '1%', right: '1%', bgcolor: 'var(--background-main)' }}>
                {nonTvItems.map((item, index) => {
                  const sectionId = sanitizeId(String(item.id || item.nome_item));
                  return (
                    <div key={index} id={sectionId}>
                      <div className="container-clube-voucher">
                        <h2 style={{ color: 'var(--secondary)', fontSize: '16px', fontWeight: 400, padding: '12px 16px 8px' }}>
                          {item.nome_item}
                        </h2>

                        <div className="diretorio-cards-grid">
                          {item.item_diretorio_sem_cat.map((subItem, subIndex) => {
                            const descPlain = stripHtml(subItem.descricao);
                            const isLong = descPlain.length > MAX_DESC_CHARS;

                            return (
                              <div
                                key={subIndex}
                                className="diretorio-card"
                                onClick={() => setSelectedItem(subItem)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => e.key === 'Enter' && setSelectedItem(subItem)}
                              >
                                <div className="diretorio-card-header">
                                  <p className="diretorio-card-nome"
                                    dangerouslySetInnerHTML={{ __html: formatDescription(subItem.nome) }}
                                  />
                                  {subItem.valor && parseFloat(subItem.valor) > 0 && (
                                    <span className="diretorio-card-valor">
                                      R$ {parseFloat(subItem.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </span>
                                  )}
                                </div>

                                {subItem.descricao && (
                                  <p className="diretorio-card-desc">
                                    {isLong ? truncateText(subItem.descricao, MAX_DESC_CHARS) : descPlain}
                                    {isLong && <span className="diretorio-card-more"> +</span>}
                                  </p>
                                )}

                                {subItem.horario_funcionamento && (
                                  <div className="diretorio-card-horario">
                                    <AccessTimeIcon sx={{ fontSize: 14 }} />
                                    <span>{t('abertoDas')} {subItem.horario_funcionamento}</span>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Box>
            </div>
          </div>
        )}

        {value === 1 && (
          <div className="MainGrid" style={{ marginBottom: '-60px' }}>
            <div className="box" style={{ margin: '10px auto', border: 'none', background: 'var(--background-main)' }}>
              <div className="div-title-canais-tv">
                <h1>{t('canaisTv')}</h1>
              </div>
              <div className="container-card-tv">
                {tvItems[0].programacao_tv.map((item, index) => (
                  <div key={index} className="div-tv-card box">
                    <div className="div-numero-canal" style={{ background: resolvedColor }}>
                      <p style={{ color: cor_letra }}>{item.canal}</p>
                    </div>
                    <div className="div-nome-canal">
                      <p>{item.nome}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </Box>

      {/* Modal de detalhes */}
      {selectedItem && (
        <div className="diretorio-modal-overlay" onClick={() => setSelectedItem(null)}>
          <div className="diretorio-modal" onClick={(e) => e.stopPropagation()}>
            <div className="diretorio-modal-handle" />

            <div className="diretorio-modal-header">
              <h3 dangerouslySetInnerHTML={{ __html: formatDescription(selectedItem.nome) }} />
              <IconButton onClick={() => setSelectedItem(null)} size="small" aria-label="fechar">
                <CloseIcon />
              </IconButton>
            </div>

            <div className="diretorio-modal-body">
              {selectedItem.valor && parseFloat(selectedItem.valor) > 0 && (
                <div className="diretorio-modal-tag diretorio-modal-tag-valor">
                  <AttachMoneyIcon sx={{ fontSize: 16 }} />
                  R$ {parseFloat(selectedItem.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              )}
              {selectedItem.horario_funcionamento && (
                <div className="diretorio-modal-tag diretorio-modal-tag-horario">
                  <AccessTimeIcon sx={{ fontSize: 16 }} />
                  {t('abertoDas')} {selectedItem.horario_funcionamento}
                </div>
              )}
              {selectedItem.descricao && (
                <div
                  className="diretorio-modal-desc"
                  dangerouslySetInnerHTML={{ __html: formatDescription(selectedItem.descricao) }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Diretorio;
